import * as PIXI from "pixi";

export class PixelHelper {
  private readonly displayObject: PIXI.DisplayObject;
  private invalidated: boolean;
  private renderer: PIXI.Renderer;

  pixels: Uint8Array;
  x: number;
  y: number;
  width: number = 0;
  height: number = 0;

  constructor(
    renderer: PIXI.Renderer,
    displayObject: PIXI.DisplayObject,
    rect?: PIXI.Rectangle
  ) {
    this.renderer = renderer;
    this.displayObject = displayObject;

    const b = displayObject.getLocalBounds();
    this.x = rect ? rect.x + -b.x : 0;
    this.y = rect ? rect.y + -b.y : 0;
    this.width = rect?.width ?? Math.round(b.width);
    this.height = rect?.height ?? Math.round(b.height);

    this.pixels = (renderer.plugins.extract as PIXI.Extract).pixels(
      this.displayObject,
      new PIXI.Rectangle(this.x, this.y, this.width, this.height)
    );
    this.invalidated = false;
  }

  invalidate() {
    this.invalidated = true;
  }

  isInBounds(pt: PIXI.Point): boolean {
    return pt.x >= 0 && pt.y >= 0 && pt.x < this.width && pt.y < this.height;
  }

  getPixelColor(x: number, y: number): number {
    if (this.invalidated) this.refresh();

    x = Math.round(x);
    y = Math.round(y);
    const idx = (y * this.width + x) * 4;

    return (
      (this.pixels[idx] << 16) |
      (this.pixels[idx + 1] << 8) |
      this.pixels[idx + 2]
    );
  }

  getPixelAlpha(x: number, y: number): number {
    if (this.invalidated) this.refresh();

    x = Math.round(x);
    y = Math.round(y);
    return this.pixels[(y * this.width + x) * 4 + 3];
  }

  hitTest(point: PIXI.Point, tolerance: number = 80): boolean {
    if (!this.isInBounds(point)) return false;
    return this.getPixelAlpha(point.x, point.y) > tolerance;
  }

  debugImage() {
    if (this.invalidated) this.refresh();

    const image = (this.renderer.plugins.extract as PIXI.Extract).image(
      this.displayObject
    );
    document.body.appendChild(image);
  }

  refresh() {
    this.pixels = (this.renderer.plugins.extract as PIXI.Extract).pixels(
      this.displayObject,
      new PIXI.Rectangle(this.x, this.y, this.width, this.height)
    );
    this.invalidated = false;
  }
}
